import { useRef } from 'react';
import { t } from 'i18next';
// components
import { Whisper } from 'rsuite';
import { PopoverWhatsapp } from './PopoverWhatsapp';
// utils && hooks
import { useUser } from 'utils/hooks';
// styles
import styles from './TimeWithProgress.module.css';

const TimerWithProgress = ({
    maxDays,
    daysLeft,
    width,
    height,
    withTextDay,
    withPopover,
    withStrongColor,
    backgroundColor,
}) => {
    const { user } = useUser({});
    const popoverWhatsappRef = useRef(null);
    const textDays = daysLeft === 1 ? t('home.timerTrial.text.days').slice(0, -1) : t('home.timerTrial.text.days');

    let maxColor = '';
    let minColor = '';

    if (withStrongColor) {
        if (daysLeft > 7) {
            maxColor = '#07AD4B';
            minColor = '#DDF6E2';
        } else if (daysLeft > 4) {
            maxColor = '#FFC700';
            minColor = '#FFEA9F';
        } else {
            maxColor = '#FF6300';
            minColor = '#FFCDAD';
        }
    } else {
        if (daysLeft > 7) {
            maxColor = '#09ca58';
            minColor = '#ddf6e2';
        } else if (daysLeft > 4) {
            maxColor = '#FFC700';
            minColor = '#FFEA9F';
        } else {
            maxColor = '#FF8E47';
            minColor = '#FFCDAD';
        }
    }

    return (
        <Whisper
            trigger={'none'}
            ref={popoverWhatsappRef}
            placement={'bottomEnd'}
            controlId={`control-id-${user?.id}`}
            speaker={
                <PopoverWhatsapp quantity={daysLeft} action={() => popoverWhatsappRef.current.close()} user={user} />
            }
            disabled={false}
        >
            <div
                className={styles['container']}
                style={{
                    width: width,
                    height: height,
                    minWidth: width,
                    minHeight: height,
                    background: `conic-gradient(${maxColor} ${(daysLeft / maxDays) * 100}%, ${minColor} 0)`,
                    transform: 'rotate(90deg)',
                }}
                onMouseOver={() => withPopover && popoverWhatsappRef.current.open()}
            >
                <div
                    className={styles['innerCircle']}
                    style={{
                        backgroundColor,
                        width: '80%',
                        height: '80%',
                    }}
                >
                    <p
                        className={`${styles['days']} ${!withTextDay ? styles['textDay'] : ''}`}
                        style={{ color: backgroundColor !== '#fff' ? '#fff' : '#40435b' }}
                    >
                        {daysLeft < 10 ? `0${daysLeft}` : daysLeft}
                    </p>
                    {withTextDay && (
                        <p
                            className={styles['label']}
                            style={{ color: backgroundColor !== '#fff' ? '#fff' : '#40435b' }}
                        >
                            {textDays}
                        </p>
                    )}
                </div>
            </div>
        </Whisper>
    );
};

export default TimerWithProgress;
